import React, { useState, useEffect } from "react";
import axios from "axios";
import { MyUrl } from "../../../App";
import moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import CheckIcon from "@material-ui/icons/Check";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Divider } from "antd";
import Calendar from "../../../Images/Calendar.png";
import CampaignManagementCampaignOptimizationOverview from "./CampaignManagementCampaignOptimizationOverview";
import { Skeleton } from "@mui/material";
import CampaignManagementSourceOptimizationReport from "./CampaignManagementSourceOptimizationReport";
import jwt_decode from "jwt-decode";
import Lottie from "lottie-react";
import reloadpage from "../../../reloadpage.json";

var jwtToken = "";

var SendDataToCampOptimization = [];
var ObjSendDataToCampOptimization = {};

var SendDataToCampOptimization1 = [];
var ObjSendDataToCampOptimization1 = {};

var compName = "Demand";
var PickedDate = 0;
const styles = {
  root: {
    "&$checked": {
      color: "#3f51b5",
    },
  },
  checked: {},
  circle: {
    borderRadius: "50%",
    width: 20,
    height: 20,
    backgroundColor: "#fff",
    border: "2px solid #fff", // we can add color after solid
  },
  checkedIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    width: 20,
    height: 20,
    backgroundColor: "white",
  },
};

const CircleCheckbox = withStyles(styles)(({ classes, ...props }) => (
  <Checkbox
    {...props}
    classes={{
      root: classes.root,
      checked: classes.checked,
    }}
    icon={<span className={classes.circle} />}
    checkedIcon={
      <span className={classes.checkedIcon}>
        <CheckIcon style={{ fontSize: 16, color: "black" }} />
      </span>
    }
  />
));

export default function CampaignManagementGetDataAndFilter() {
  const [isClicked, setIsClicked] = useState(false);

  const ChooceTable = ["Demand", "Supply"];
  const [CompColor, setCompColor] = useState(0);

  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();
  //const MyToken = JSON.parse(localStorage.getItem("Token"));
  // const MyToken = JSON.parse(sessionStorage.getItem("Token"));
  // const base64Url = MyToken.split(".")[1];
  // const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  // const payload = JSON.parse(atob(base64));
  // const expirationDate = new Date(payload.exp * 1000);
  // const currentTime = new Date().getTime(); // Get the current time in milliseconds
  const [CheckTypeOfUser, setCheckTypeOfUser] = useState("");

  const RefreshFunc1 = async () => {
    const token = sessionStorage.getItem("Token");
    var parsed = JSON.parse(token);
    const decodedToken = jwt_decode(token);
    const role =
      decodedToken[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ];
    setCheckTypeOfUser(role);
    jwtToken = JSON.parse(token);
    const base64Url = JSON.parse(token).split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));
    const expirationDate = new Date(payload.exp * 1000);
    const currentTime = new Date().getTime(); // Get the current time in milliseconds
    console.log(expirationDate);
    console.log(currentTime);
    console.log(JSON.parse(token));
    if (expirationDate < currentTime) {
      console.log("New Token");
      //try {
      await axios
        .post(
          `${MyUrl}/api/RefreshToken/refresh`,
          { accessToken: JSON.parse(token).replace("Bearer ", "") },
          { withCredentials: true }
        )
        .then(async (response) => {
          parsed = response.data.accessToken;
          const updatedObjString = JSON.stringify(response.data.accessToken);
          sessionStorage.setItem(
            "Token",
            JSON.stringify(response.data.accessToken)
          );
          GetDailyIncomeFunc(response.data.accessToken);
          GetCampOptimizationDataFunc(startDate, endDate);
          GetSupplyReportsCampOptimizationDataFunc(startDate, endDate);
          GetMonthlyIncomeFunc(startDate, endDate);
          return () => {
            source.cancel("Component unmounted");
          };
        })
        .catch((error) => {
          console.log(error);
        });
      //await RefreshFunc(Today, Today);
      // } catch (error) {
      //   console.log(error);
      // }
    } else {
      console.log("Old Token");
      const items = sessionStorage.getItem("Token");
      var parsed = JSON.parse(items);
      jwtToken = JSON.parse(items);
      GetDailyIncomeFunc(JSON.parse(items));
      GetCampOptimizationDataFunc(startDate, endDate);
      GetSupplyReportsCampOptimizationDataFunc(startDate, endDate);
      GetMonthlyIncomeFunc(startDate, endDate);
      //RefreshFunc(Today, Today);
      return () => {
        source.cancel("Component unmounted");
      };
    }
    //await RefreshFunc(Today, Today);
  };

  const RefreshFunc = async (startDate, endDate) => {
    const token = sessionStorage.getItem("Token");
    var parsed = JSON.parse(token);
    const decodedToken = jwt_decode(token);
    const role =
      decodedToken[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ];
    setCheckTypeOfUser(role);
    jwtToken = JSON.parse(token); //parsed;
    const base64Url = JSON.parse(token).split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));
    const expirationDate = new Date(payload.exp * 1000);
    const currentTime = new Date().getTime(); // Get the current time in milliseconds
    if (expirationDate < currentTime) {
      try {
        axios
          .post(
            `${MyUrl}/api/RefreshToken/refresh`,
            { accessToken: JSON.parse(token).replace("Bearer ", "") },
            { withCredentials: true }
          )
          .then((response) => {
            parsed = response.data.accessToken;
            const updatedObjString = JSON.stringify(response.data.accessToken);
            sessionStorage.setItem(
              "Token",
              JSON.stringify(response.data.accessToken)
            );
            GetCampOptimizationDataFunc(startDate, endDate);
            GetSupplyReportsCampOptimizationDataFunc(startDate, endDate);
            GetMonthlyIncomeFunc(startDate, endDate);
            return () => {
              source.cancel("Component unmounted");
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      const items = sessionStorage.getItem("Token");
      var parsed = JSON.parse(items);
      jwtToken = JSON.parse(items); //parsed;
      GetCampOptimizationDataFunc(startDate, endDate);
      GetSupplyReportsCampOptimizationDataFunc(startDate, endDate);
      GetMonthlyIncomeFunc(startDate, endDate);
      return () => {
        source.cancel("Component unmounted");
      };
    }
  };

  useEffect(() => {
    setChooceCompanies([]);
    //PickDatesToGetData(0);
    RefreshFunc1();
    //   RefreshFunc(Today, Today);
  }, []);
  const [chooceCompanies, setChooceCompanies] = useState([]);
  const [ChooseBNamesForGraph, setChooseBNamesForGraph] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState("");
  const [isLoading1, setIsLoading1] = useState(true);
  const [data1, setData1] = useState("");
  const [isLoading2, setIsLoading2] = useState(true);
  const [data2, setData2] = useState("");
  const [isLoading7, setIsLoading7] = useState(true);
  const [data7, setData7] = useState("");

  const [isLoading5, setIsLoading5] = useState(true);
  const [data5, setData5] = useState("");

  //when pick today
  const Today = moment().add("days").format("YYYY-MM-DD");
  //when pick yesterday
  const Yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
  //when pick 7 days
  const SevenDays = moment().subtract(7, "day").format("YYYY-MM-DD");

  var LastDayInMonth = moment(LastDayInMonth)
    .endOf("month")
    .format("YYYY-MM-DD");

  var FirstDayInMonth = moment(FirstDayInMonth)
    .startOf("month")
    .format("YYYY-MM-DD");

  const currentDate = moment();
  const daysInCurrentMonth = currentDate.daysInMonth();

  const handleCheckboxChange = (event, productName) => {
    if (event.target.checked) {
      setChooceCompanies([...chooceCompanies, productName]); // add to array
    } else {
      setChooceCompanies(
        chooceCompanies.filter((name) => name !== productName)
      ); // remove from array
    }
  };

  const products = ["Product A", "Product B", "Product C"];
  // console.log(chooceCompanies);

  const idsArray = [1, 2, 3, 4];

  const IdsToGetData = chooceCompanies
    .map((id) => "&ids=" + String(id))
    .join("");

  //  console.log(IdsToGetData); // "&ids=1&ids=2&ids=3&ids=4"
  const GetSupplyReportsCampOptimizationDataFunc = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    //console.log(items);
    var parsed = JSON.parse(items);
    //console.log(parsed);

    setIsLoading5(true);
    SendDataToCampOptimization1 = [];
    try {
      axios
        .get(
          `${MyUrl}/api/MediaSource/sourceOptimization?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}
              `,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data5 = res.data;
          setData5(data5);
          console.log(data5);
          SendDataToCampOptimization1 = [];
          for (let i = 0; i < data5.responseData.data.length; i++) {
            ObjSendDataToCampOptimization1 = {
              //  Id: data5.responseData.data[i].campaign.id,
              source: data5.responseData.data[i].source.name,
              SEAT: data5.responseData.data[i].seatName,
              ENV: data5.responseData.data[i].environment.name,
              Req: data5.responseData.data[i].ad_requests,
              Imp: data5.responseData.data[i].impressions_good,
              Fill: data5.responseData.data[i].fill,
              Revenue: data5.responseData.data[i].revenue_total,
              trafficSource: data5.responseData.data[i].trafficSource,

              QS: Number.parseFloat(
                data5.responseData.data[i].qs.toString().replace("e-", "")
              ).toFixed(2),
            };
            SendDataToCampOptimization1.push(ObjSendDataToCampOptimization1);
            //console.log(SendDataToCampOptimization);
          }
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading5(false);
        });
    } catch (error) {}
  };

  // const GetDailyIncomeFunc = async (a) => {
  //   const items = sessionStorage.getItem("Token");
  //   var parsed = JSON.parse(items);
  //   console.log("GetDailyIncomeFunc");
  //   setIsLoading(true);
  //   try {
  //     let base64 = require("base-64"); // install it before use from npm i base-64
  //     axios
  //       .get(
  //         `${MyUrl}/api/Dashboard/getDailyIncome?&startDate=${startDate}&endDate=${endDate}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${a.replace("Bearer ", "")}`,
  //           },
  //           cancelToken: source.token,
  //         }
  //       )
  //       .then((res) => {
  //         const data = res.data;
  //         setData(data);
  //         //       console.log(data);
  //         for (let i = 0; i < data.responseData.length; i++) {
  //           console.log(data.responseData[i].id);

  //           setChooceCompanies((prevCompanies) => [
  //             ...prevCompanies,
  //             data.responseData[i].id,
  //           ]);
  //         }
  //       })
  //       .catch((error) => {})
  //       .finally(() => {
  //         setIsLoading(false);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const GetDailyIncomeFunc = (a) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);
    setIsLoading(true);
    try {
      let base64 = require("base-64"); // install it before use from npm i base-64
      axios
        .get(`${MyUrl}/api/Account/userSeats`, {
          headers: {
            Authorization: `Bearer ${a.replace("Bearer ", "")}`,
            //Authorization: `Bearer ${JSON.parse(items).replace("Bearer ", "")}`,
          },
          cancelToken: source.token,
        })
        .then((res) => {
          const data = res.data;
          setData(data);
          console.log(data);
          for (let i = 0; i < data.length; i++) {
            setChooceCompanies((prevCompanies) => [
              ...prevCompanies,
              data[i].id,
            ]);
          }
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const GetCampOptimizationDataFunc = (startDate, endDate) => {
    setIsLoading7(true);

    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);
    try {
      axios
        .get(
          `${MyUrl}/api/DemandReport/campOptimization?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}
              `,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data7 = res.data;
          setData7(data7);
          SendDataToCampOptimization = [];
          ObjSendDataToCampOptimization = {};
          for (let i = 0; i < data7.responseData.data.length; i++) {
            ObjSendDataToCampOptimization = {
              Id: data7.responseData.data[i].campaign.id,
              CampaignName: data7.responseData.data[i].campaign.name,
              SEAT: data7.responseData.data[i].seatName,
              ENV: data7.responseData.data[i].environment.name,
              Req: data7.responseData.data[i].ad_requests,
              Imp: data7.responseData.data[i].impressions_good,
              Fill: data7.responseData.data[i].fill,
              Revenue: data7.responseData.data[i].revenue_total,
              QS: Number.parseFloat(
                data7.responseData.data[i].qs.toString().replace("e-", "")
              ).toFixed(2),
            };
            SendDataToCampOptimization.push(ObjSendDataToCampOptimization);
          }
        })
        .catch((error) => {})
        .finally(() => {
          setTimeout(() => setIsLoading7(false), 2000);
        });
    } catch (error) {}
  };

  const handleChange2 = (value) => {
    console.log(`selected ${value}`);
  };

  const GetDailyIncomeFunc1 = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);

    setIsLoading2(true);
    try {
      let base64 = require("base-64"); // install it before use from npm i base-64
      axios
        .get(
          `${MyUrl}/api/Dashboard/getDailyIncome?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          const data2 = res.data;
          setData2(data2);
          //         console.log(data2);
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading2(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const GetMonthlyIncomeFunc = (startDate, endDate) => {
    const items = sessionStorage.getItem("Token");
    var parsed = JSON.parse(items);

    console.log("GetMonthlyIncomeFunc");
    setIsLoading1(true);
    try {
      axios
        .get(
          `${MyUrl}/api/Dashboard/getMonthlyIncome?${IdsToGetData}&startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${parsed.replace("Bearer ", "")}`,
            },
            cancelToken: source.token,
          }
        )
        .then((res) => {
          //console.log("data1");
          const data1 = res.data;
          setData1(data1);
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading1(false);
        });
    } catch (error) {}
  };

  //For CheckBox
  const [checked, setChecked] = useState(false);

  //End for CheckBox

  //Select Days
  const [days, setDays] = React.useState(0);
  const handleChangeDays = (event) => {
    setDays(event.target.value);
    // PickDatesToGetData(event.target.value);
  };
  //End select Days

  const [OpenRange, SetOpenRange] = useState(false);
  var startDate = Today;
  var endDate = Today;

  async function PickDatesToGetData(event) {
    setDays(event);
    if (event === 0) {
      SetOpenRange(false);
      startDate = Today;
      endDate = Today;
      await RefreshFunc(startDate, endDate);
      // GetDailyIncomeFunc1(Today, Today);
      // GetMonthlyIncomeFunc(Today, Today);
    } else if (event === 1) {
      SetOpenRange(false);
      startDate = Yesterday;
      endDate = Yesterday;
      await RefreshFunc(startDate, endDate);
    } else if (event === 2) {
      SetOpenRange(false);
      startDate = SevenDays;
      endDate = Yesterday;
      await RefreshFunc(startDate, endDate);
    } else if (event === 3) {
      SetOpenRange(false);
      startDate = FirstDayInMonth;
      endDate = Yesterday;
      await RefreshFunc(startDate, endDate);
    } else if (event === 4) {
      if (value.$D === undefined) {
        startDate = Today;
      } else {
        startDate = `${value.$y}-${value.$M + 1}-${value.$D}`;
      }
      if (value1.$D === undefined) {
        endDate = Today;
      } else {
        endDate = `${value1.$y}-${value1.$M + 1}-${value1.$D}`;
      }
      SetOpenRange(true);
      await RefreshFunc(startDate, endDate);
    }
  }

  useEffect(() => {
    // This code will run only when myVariable changes
    //   console.log("myVariable changed to", OpenRange);
  }, [OpenRange]);
  //console.log("Number of days in current month:", daysInCurrentMonth);

  //For Date Pick

  var [value, setValue] = React.useState(startDate);
  var [value1, setValue1] = React.useState(endDate);
  const handleChange3 = (newValue) => {
    setValue(newValue);
    startDate = `${newValue.$y}-${newValue.$M + 1}-${newValue.$D}`;
    console.log(`startDate = ${newValue.$y}-${newValue.$M + 1}-${newValue.$D}`);
  };

  const handleChange4 = (newValue1) => {
    setValue1(newValue1);
    endDate = `${newValue1.$y}-${newValue1.$M + 1}-${newValue1.$D}`;
    console.log(
      `endDate = ${newValue1.$y}-${newValue1.$M + 1}-${newValue1.$D}`
    );
  };

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();
  return (
    <div style={{ paddingLeft: "2.5%", paddingRight: "1%", paddingTop: 30 }}>
      <h2>Select Products:</h2>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            overflowX: width > 766 ? "" : "scroll",
          }}
        >
          {" "}
          <Skeleton
            animation="wave"
            //sx={{ bgcolor: "grey.900" }}
            // variant="rectangular"
            width={750}
            height={80}
            borderRadius={100}
          />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                // display: "flex",
                // flexDirection: "row",
                display: "flex",
                flexDirection: "row",
                overflowX: width > 766 ? "" : "scroll",
              }}
            >
              {Array.isArray(data) ? (
                data &&
                data.map((responseData) => (
                  <div>
                    <div
                      key={responseData.id}
                      style={{
                        display: "flex",
                        background: responseData.color,
                        borderRadius: 100,
                        justifyContent: "center",
                        alignItems: "center",
                        margin: 3,
                        paddingRight: 5,
                        height: 40,
                      }}
                    >
                      <CircleCheckbox
                        checked={chooceCompanies.includes(responseData.id)}
                        onChange={(event) =>
                          handleCheckboxChange(event, responseData.id)
                        }
                      />
                      <label>{responseData.name}</label>
                    </div>
                  </div>
                ))
              ) : (
                <>
                  <h5>There is no companies!</h5>
                </>
              )}
              <button
                style={{
                  border: "none",
                  background: "white",
                  cursor: "pointer",
                  minWidth: 60,
                }}
                onClick={() => {
                  PickDatesToGetData(PickedDate);
                  setIsClicked(true);
                  setTimeout(() => setIsClicked(false), 1000);
                }}
              >
                <Lottie
                  loop={isClicked ? true : false}
                  autoplay={isClicked ? true : false}
                  animationData={reloadpage}
                  rendererSettings={{
                    preserveAspectRatio: "xMidYMid slice",
                    display: "flex",
                    background: "white",
                    borderRadius: 100,
                    justifyContent: "center",
                    alignItems: "center",
                    margin: 3,
                    paddingRight: 5,
                    height: 40,
                    width: 60,
                    minWidth: 60,
                  }}
                  isPaused={isClicked}
                />
              </button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingRight: "1%",
              }}
            >
              <Box sx={{ minWidth: 150 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">days</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={days}
                    label="days"
                    onChange={handleChangeDays}
                  >
                    <MenuItem
                      sx={{ width: 200 }}
                      value={0}
                      onClick={() => {
                        PickedDate = 0;
                        PickDatesToGetData(0);
                      }}
                    >
                      Today
                    </MenuItem>
                    <MenuItem
                      value={1}
                      onClick={() => {
                        PickedDate = 1;
                        PickDatesToGetData(1);
                      }}
                    >
                      Yesterday
                    </MenuItem>
                    <MenuItem
                      value={2}
                      onClick={() => {
                        PickedDate = 2;
                        PickDatesToGetData(2);
                      }}
                    >
                      Last 7 Days
                    </MenuItem>
                    <MenuItem
                      value={3}
                      onClick={() => {
                        PickedDate = 3;
                        PickDatesToGetData(3);
                      }}
                    >
                      This Months
                    </MenuItem>
                    <div style={{ height: 1 }}>
                      <Divider />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="From Date"
                          inputFormat="DD-MM-YYYY"
                          value={value}
                          onChange={handleChange3}
                          renderInput={(params) => <TextField {...params} />}
                        />
                        &nbsp;&nbsp;
                        <DesktopDatePicker
                          label="To Date"
                          inputFormat="DD-MM-YYYY"
                          value={value1}
                          onChange={handleChange4}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </div>

                    <br></br>

                    <MenuItem
                      value={4}
                      onClick={() => {
                        SetOpenRange(true);
                        // PickDatesToGetData(4);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "black",
                            textTransform: "none",
                            fontSize: "100%",
                            borderRadius: "12px",
                          }}
                          onClick={() => {
                            if (value === "" || value1 === "") {
                              console.log("Wrong");
                            } else {
                              console.log("Call Data");
                              SetOpenRange(false);
                              PickedDate = 4;
                              PickDatesToGetData(4);
                            }
                          }}
                        >
                          {/* Filter */}
                          Custom Range
                        </Button>
                      </div>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>
        </>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      ></div>
      <span style={{ color: "#1a1523", fontSize: 18 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Top &nbsp;&nbsp; */}
          {ChooceTable.map((responseData, i) => (
            <div
              style={{
                background: "#f4f2f4",
                borderTopLeftRadius: i === 0 ? 50 : 0,
                borderBottomLeftRadius: i === 0 ? 50 : 0,
                borderTopRightRadius: i === ChooceTable.length - 1 ? 50 : 0,
                borderBottomRightRadius: i === ChooceTable.length - 1 ? 50 : 0,
                height: 40,
                alignItems: "center",
                paddingLeft: i === 0 ? 3 : 0,
                paddingRight: i === ChooceTable.length - 1 ? 3 : 0,
                //justifyContent: "center",
                display: "flex",
              }}
            >
              <button
                value={responseData}
                style={{
                  borderWidth: 0,
                  borderRadius: 50,
                  background: CompColor === i ? "white" : "#f4f2f4",
                  height: 35,
                  fontWeight: CompColor === i ? "bold" : "",
                  fontSize: 14,
                  minWidth: 80,
                }}
                onClick={() => {
                  setCompColor(i);
                  compName = responseData;
                  // setComponentName(responseData.component.name);
                  console.log(responseData);
                }}
              >
                {responseData}
              </button>
              {i !== ChooceTable.length - 1 ? (
                <div
                  style={{
                    width: 1,
                    height: 16,
                    flexGrow: 0,
                    background: "#c8c7cb",
                  }}
                ></div>
              ) : (
                <></>
              )}
            </div>
          ))}
        </div>
      </span>

      {compName === "Demand" ? (
        <>
          {isLoading7 ? (
            <Skeleton
              animation="wave"
              //sx={{ bgcolor: "grey.900" }}
              // variant="rectangular"
              //width={750}
              height={500}
              borderRadius={100}
            />
          ) : (
            <>
              <CampaignManagementCampaignOptimizationOverview
                SendDataToCampOptimization={SendDataToCampOptimization}
                startDate={startDate}
                endDate={endDate}
              />
            </>
          )}
        </>
      ) : (
        <>
          {isLoading5 ? (
            <>
              {" "}
              <Skeleton
                animation="wave"
                //sx={{ bgcolor: "grey.900" }}
                // variant="rectangular"
                //  width={750}
                height={500}
                borderRadius={100}
              />
            </>
          ) : (
            <>
              <CampaignManagementSourceOptimizationReport
                startDate={startDate}
                endDate={endDate}
                SendDataToCampOptimization1={SendDataToCampOptimization1}
              />
            </>
          )}
        </>
      )}
    </div>
  );
}
